import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function IntegrationActionNode({ id, data }) {
    return (
        <NodeComponent title="Integration" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

